import { FC, useMemo } from "react"
import { IToothIPRData } from "./index"
import Polyline from "./Polyline"
import "./scss/MyUpPolyline.scss"

interface IProps {
  toothIPRData: IToothIPRData
}
const MyLowPolyline: FC<IProps> = ({ toothIPRData }) => {
  const pl = 26
  const itemWidth = 50
  const width = 850
  const { iprLRToothDataMemo, iprLLToothDataMemo } = toothIPRData
  const toothPos = [
    170, 215, 253, 278, 308, 343, 368, 395, 421, 448, 482, 513, 535, 573, 613,
    645,
  ]
  const getLowList = useMemo(() => {
    const upList = [...iprLRToothDataMemo, ...iprLLToothDataMemo]
    const isNotMissingData = upList.filter((item) => !item.isMissingTooth)
    const findIndexs = upList
      .map((item, index) => {
        if (item.isMissingTooth) return index
      })
      .filter((item) => item !== undefined)

    const toothPosMap = toothPos.filter(
      (item, index) => !findIndexs.includes(index),
    )
    const posData = isNotMissingData.map((item, index) => {
      const left =
        itemWidth * index +
        pl +
        ((width - itemWidth * isNotMissingData.length) /
          (isNotMissingData.length - 1)) *
          index

      return {
        ...item,
        point: [toothPosMap[index], 0, toothPosMap[index], 35, left, 90],
      }
    })
    return posData
  }, [toothIPRData.iprLRToothDataMemo, toothIPRData.iprLLToothDataMemo])

  return (
    <div className="my-low-polyline">
      {getLowList.length > 0 &&
        getLowList.map((item, index) => {
          return (
            <div key={index} className="item-polyline">
              <Polyline point={item.point} />
            </div>
          )
        })}
    </div>
  )
}

export default MyLowPolyline
